// extracted by mini-css-extract-plugin
export default {"factsHolder":"FactHolder_factsHolder__k35YP","fact":"FactHolder_fact__K8W3k","factKey":"FactHolder_factKey__yi+dY"};